import { render, staticRenderFns } from "./Reaction.vue?vue&type=template&id=10442b88&scoped=true&"
import script from "./Reaction.vue?vue&type=script&lang=ts&"
export * from "./Reaction.vue?vue&type=script&lang=ts&"
import style0 from "./Reaction.vue?vue&type=style&index=0&id=10442b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10442b88",
  null
  
)

export default component.exports